<template>
  <section class="where-we-work-box" id="where-we-work">
    <div class="section-container-header-box fade-up-animation">
      <p class="list-text">Where we work</p>
    </div>
    <h2 class="where-we-work-box-heading">
      <p class="extra-large-text-list fade-up-animation">Industries we</p>
      <p class="extra-large-text-list special-text fade-up-animation">know deeply.</p>
    </h2>

    <!-- Desktop / tablet: grid -->
    <div class="where-we-work-box-items">
      <div v-for="industry in numberedIndustries" :key="industry.name" class="where-we-work-card fade-up-animation">
        <span class="where-we-work-card-index">{{ industry.number }}</span>
        <div class="where-we-work-card-content">
          <h3 class="heading-3" v-html="industry.name"></h3>
          <p class="body-text" v-html="industry.description"></p>
        </div>
      </div>
    </div>

    <!-- Mobile: swiper -->
    <SwiperComponent :items="numberedIndustries" childrenClass=".where-we-work-card-mobile">
      <template #item="{ item }">
        <div class="where-we-work-card where-we-work-card-mobile fade-up-animation">
          <span class="where-we-work-card-index">{{ item.number }}</span>
          <div class="where-we-work-card-content">
            <h3 class="heading-3" v-html="item.name"></h3>
            <p class="body-text" v-html="item.description"></p>
          </div>
        </div>
      </template>
    </SwiperComponent>
  </section>
</template>

<script lang="ts" setup>
import { useFadeUpObserver } from '@/composables/useFadeUpObserver';
import { industries } from '@/data/industries';

// Pre-number so both the grid and the swiper slot (which only exposes `item`)
// can render the same index numeral.
const numberedIndustries = industries.map((industry, index) => ({
  ...industry,
  number: String(index + 1).padStart(2, '0'),
}));

useFadeUpObserver();
</script>
